if (!customElements.get('skinmedicine-product')) {
  class SkinmedicineProduct extends HTMLElement {
    connectedCallback() {
      this.mainMedia = [...this.querySelectorAll('[data-product-media]')];
      this.thumbnails = [...this.querySelectorAll('[data-product-thumbnail]')];
      this.tabs = [...this.querySelectorAll('[data-product-tab]')];
      this.panels = [...this.querySelectorAll('[data-product-panel]')];
      this.quantityInput = this.querySelector('[data-product-quantity]');

      this.thumbnails.forEach((button) => button.addEventListener('click', () => this.selectMedia(button.dataset.productThumbnail)));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab.dataset.productTab, true));
        tab.addEventListener('keydown', (event) => this.handleTabKeydown(event));
      });
      this.querySelectorAll('[data-quantity-change]').forEach((button) => button.addEventListener('click', () => this.changeQuantity(Number(button.dataset.quantityChange))));
      this.querySelectorAll('[data-variant-radio]').forEach((radio) => radio.addEventListener('change', () => this.selectVariant(radio)));
    }

    selectMedia(id) {
      this.mainMedia.forEach((media) => {
        const selected = media.dataset.productMedia === id;
        media.hidden = !selected;
      });
      this.thumbnails.forEach((button) => button.setAttribute('aria-current', button.dataset.productThumbnail === id ? 'true' : 'false'));
    }

    selectTab(name, focus = false) {
      this.tabs.forEach((tab) => {
        const selected = tab.dataset.productTab === name;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected && focus) tab.focus();
      });
      this.panels.forEach((panel) => { panel.hidden = panel.dataset.productPanel !== name; });
    }

    handleTabKeydown(event) {
      const index = this.tabs.indexOf(event.currentTarget);
      let next = null;
      if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.tabs.length - 1;
      if (next === null) return;
      event.preventDefault();
      this.selectTab(this.tabs[next].dataset.productTab, true);
    }

    changeQuantity(delta) {
      if (!this.quantityInput) return;
      const minimum = Number(this.quantityInput.min || 1);
      const maximum = Number(this.quantityInput.max || Number.MAX_SAFE_INTEGER);
      const next = Math.max(minimum, Math.min(maximum, Number(this.quantityInput.value || minimum) + delta));
      this.quantityInput.value = next;
      this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    selectVariant(radio) {
      this.querySelectorAll('input[name="id"]').forEach((input) => { input.value = radio.value; });
      const price = this.querySelector('[data-product-price]');
      if (price) price.textContent = radio.dataset.price;
      const available = radio.dataset.available === 'true';
      this.querySelectorAll('[data-product-submit]').forEach((button) => { button.disabled = !available; });
    }
  }

  customElements.define('skinmedicine-product', SkinmedicineProduct);
}
